import React from 'react'
import Popup from 'reactjs-popup'
import axios from 'lib/axios'
import { Alert } from 'react-bootstrap'
import { map, find, sortBy } from 'lodash'
import 'reactjs-popup/dist/index.css'
import Select from 'UI/Select'
import DatePicker from "react-datepicker";

const PopupForm = ({ fieldNames, url, modelName, actionType = 'New', formableObject = {} }) => {
  const [fields, handleFieldValue] = React.useState(formableObject)
  const [savingForm, updateSaveState] = React.useState(false)
  const [responseMessage, setResponseMessage] = React.useState(null)
  const newButton = <button className="btn btn-success mt-2 mr-2">{actionType} {modelName.shortend}</button>
  const editButton = <span className="fas fa-edit" style={{ cursor: 'pointer' }} />
  const formTrigger = actionType == 'New' ? newButton : editButton

  const handleResponseMessage = (response, success = false) => {
    setResponseMessage(response.message)
    updateSaveState(false)

    if (success) { setTimeout(() => window.location.reload(), 1000) }
  }

  const handleSubmit = () => {
    updateSaveState(true)

    if (actionType == 'New') {
      axios.post(url, { [modelName.paramsName]: fields })
        .then(({ data }) => { handleResponseMessage(data, true) })
        .catch(({ response }) => { handleResponseMessage(response.data) })
    } else {
      axios.patch(url, { [modelName.paramsName]: fields })
        .then(({ data }) => { handleResponseMessage(data, true) })
        .catch(({ response }) => { handleResponseMessage(response.data) })
    }
  }

  return (
    <Popup trigger={formTrigger} modal onOpen={() => handleFieldValue(formableObject)}>
      {close => (
        <div className="modal-popup">
          <div className="header">{actionType} {modelName.humanized}</div>
          {responseMessage && (
            <Alert variant={responseMessage.variant}>
              {responseMessage.text}
            </Alert>
          )}
          <div className="content row ml-0">
            {map(sortBy(fieldNames, 'order'), field => (
              <div className="col-6 mb-3">
                <label>{field.label}</label>

                {field.type == 'text' && (
                  <input
                    type="text"
                    value={fields[field.value]}
                    onChange={event => handleFieldValue(Object.assign({}, fields, { [field.value]: event.target.value }))}
                  />
                )}

                {field.type =='select' && (
                  <Select
                    options={field.selectOptions}
                    value={find(field.selectOptions, option => option.value == fields[field.value])}
                    onChange={({ value }) => handleFieldValue(Object.assign({}, fields, { [field.value]: value }))}
                  />
                )}

                {field.type =='date' && (
                  <DatePicker
                    selected={fields[field.value]}
                    onChange={date => handleFieldValue(Object.assign({}, fields, { [field.value]: date }))}
                    timeInputLabel="Time:"
                    dateFormat="MM/dd/yyyy h:mm aa"
                    showTimeInput
                  />
                )}
              </div>
            ))}
          </div>
          <div className="actions">
            <button className="btn btn-outline-primary mr-2" onClick={close}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={() => handleSubmit()} disabled={savingForm}>
              {savingForm ? 'Saving' : 'Save'}
            </button>
          </div>
        </div>
      )}
    </Popup>
  )
}

export default PopupForm
